import * as Sentry from '@sentry/browser';
import { contentAPI, checkoutAPI } from '../config';
import { getAllCookies } from './dom';

const getDataOptions = (body) => {
	const fetchOptions = {
		method: 'GET',
		mode: 'cors',
		cache: 'no-cache',
	};

	const cookies = getAllCookies();

	if (cookies?.previewCode) body.previewCode = cookies.previewCode;

	if (!body.restrictedCode) delete body.restrictedCode;
	if (!body.restrictedId) delete body.restrictedId;
	if (!body.previewCode) delete body.previewCode;
	if (!body.forceCountry) delete body.forceCountry;
	if (!body.country) delete body.country;
	if (body.forceCountry && body.country) delete body.country;
	if (!body.market) delete body.market;
	if (!body.pricelist) delete body.pricelist;
	if (!body.campaignSite) delete body.campaignSite;

	if (typeof process !== 'undefined' && process.env.API) {
		fetchOptions.headers = {
			'api-authorization': process.env.API,
		};
		if (body.ip) fetchOptions.headers['x-forwarded-for'] = body.ip;
		delete body.ip;
	}

	if (body !== null && typeof body === 'object' && Object.keys(body).length > 0) {
		fetchOptions.method = 'POST';
		fetchOptions.accept = 'application/json, text/plain, */*;';
		fetchOptions.body = JSON.stringify(body);
	}

	return fetchOptions;
};

const fetchData = (path, body = {}) => {
	const encodedPath = path.split('/').map((part) => encodeURIComponent(part)).join('/');
	return fetch(`${contentAPI}${encodedPath}`, getDataOptions(body))
		.then((resp) => resp.text())
		.then((data) => {
			if (data.slice(0, 1) !== '<') return JSON.parse(data);
			console.log('DEBUG: data', data);
			return data;
		}).catch((err) => {
			Sentry.captureException(err);
			console.log(`DEBUG: was not able to be fetched ${contentAPI}${encodedPath}`, err);
		});
};

const getCheckoutOptions = (token, body, method) => {
	const fetchOptions = {
		mode: 'cors',
		cache: 'no-cache',
	};

	fetchOptions.method = method;
	if (typeof process !== 'undefined' && process.env.CHECKOUT_API) {
		fetchOptions.headers = {
			Authorization: `Bearer ${process.env.CHECKOUT_API}`,
		};
	}

	if (token) fetchOptions.headers = { Accept: `application/json, text/plain, */*; api-token:${token}` };

	if (typeof body === 'object' && Object.keys(body).length > 0) {
		fetchOptions.body = JSON.stringify(body);
	}

	return fetchOptions;
};

const fetchCheckout = (path, token, body = {}, method = 'GET') => {
	const encodedPath = path.split('/').map((part) => encodeURIComponent(part)).join('/');
	// debug: return fetch(`${checkoutAPI}${encodedPath}`, getCheckoutOptions(token, body, method)).then((resp) => console.log('DEBUG: resp', resp)).catch((err) => console.log('DEBUG: was not able to be fetched', err));
	return fetch(`${checkoutAPI}${encodedPath}`, getCheckoutOptions(token, body, method)).then((data) => data.json()).catch((err) => {
		Sentry.captureException(err);
		console.error('DEBUG: was not able to be fetched', err);
	});
};

if (typeof window !== 'undefined') window.fetchCheckout = fetchCheckout;

export { fetchData, fetchCheckout };
